// src/util/soft_expire.js
import { setAuthToken } from "./session_api_util";
import { emitSessionExpired } from "./auth_events";
import { setSessionExpired } from "../actions/session_actions";

export const softExpire = (reason = "401") => {
  // ✅ prevent repeats / storms
  if (window.__COSMETINK_SOFT_EXPIRED__) return;
  window.__COSMETINK_SOFT_EXPIRED__ = true;

  const hash = window.location.hash || "";

  // Don't fire if already on login
  if (hash.includes("#/login")) {
    // still mark redux expired so routes behave consistently
    try {
      window.__COSMETINK_STORE__?.dispatch?.(setSessionExpired(reason));
    } catch (e) {}
    emitSessionExpired(reason);
    return;
  }

  // remember where they were (HashRouter)
  try {
    sessionStorage.setItem("returnTo", hash || "#/dashboard");
  } catch (e) {}

  // remove token so future requests don't pretend
  try {
    localStorage.removeItem("jwtToken");
  } catch (e) {}

  // clear axios auth header
  setAuthToken(false);

  // ✅ mark session expired in redux (DO NOT hard logout abruptly)
  try {
    window.__COSMETINK_STORE__?.dispatch?.(setSessionExpired(reason));
  } catch (e) {}

  // ✅ show the modal overlay
  emitSessionExpired(reason);
};
